import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Description() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Description
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Description
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Description-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Project background
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Description-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Guanine crystals in cosmetics
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Description-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Guanine crystals production
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Description-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Procedure
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Description-5")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    References
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Description-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Project background
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                The use of cosmetics and beauty products has been practised in society since ancient
                                times and still makes a large part of everyone’s daily self-care routines. However,
                                the environmental and social impacts associated with the cosmetics ingredients
                                production processes are not widely acknowledged nor global measures are taken to
                                improve the current state of the beauty industry (1).
                            </div>
                            <div className="mt-5">
                                As the cosmetic industry grows, the demand for sustainable ingredients simultaneously
                                increases. In 2022 it was estimated that the market for sustainable cosmetics would
                                expand from 642 million dollars to 1095 million by 2030. That growth symbolizes the
                                shift in increased customers prioritizing natural components in beauty and cosmetic
                                products (2).
                            </div>
                            <div className="mt-5">
                                However, having cruelty-free products is not enough. Today there is also a high
                                demand for ethically sourced products in the cosmetic industry. Thus, with time more
                                and more, companies are realizing the necessity of ethical, natural, and sustainable
                                beauty products. Therefore, the increase in ethical certifications such as
                                cruelty-free and fair-trade labels, demonstrates the shift and commitment of the
                                companies to respond to the contemporary world’s trends (3).
                            </div>
                            <div className="mt-5">
                                Still, concerns remain. Animal exploitation, deforestation, heavy metals,
                                environmental pollution, non-biodegradable, and bioaccumulative materials are a few
                                major concerns. There is an increasing need for synthetic substitutes created
                                ethically and environmentally friendly without decreasing efficiency and shelf-life (2).
                            </div>
                            <div className="mt-5">
                                We therefore want to create ingredients for cosmetics products using synthetic biology.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Description-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Guanine crystals in cosmetics
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Guanine crystals, colloquially pearl essence or pearlescence, is an important
                                ingredient in many cosmetics including skin care, bath, cleansing and nail products,
                                where it adds opacity and iridescent color (4). It is primarily sourced from fish
                                scales, which involves both ethical and ecological issues that in turn present a
                                barrier to entry for consumers (5). In many cosmetics the shimmer effects are also
                                created using the mineral mica. It provides opacity and gives a pearly shiny
                                appearance. Mica is not harmful as an ingredient in products. However, there are many
                                challenges since mica is commonly obtained in regions involved with child labor and
                                unethical working conditions (7). After extraction, mica is usually coated with metal
                                oxides (8).
                            </div>
                            <div className="mt-5">
                                Many of these issues could be resolved if guanine crystals could be synthesized by
                                synthetic biology. The global guanine market is also expected to reach 474.52 million
                                by 2027, which is why we think guanine crystals are a promising ingredient used in
                                cosmetics to produce synthetically.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/description/description-1.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="mt-5 text-center">
                                Image 1. Global Guanine Market, 2027 (USD Million)
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Description-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Guanine crystals production
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Guanine is mostly known as one of the four bases of the nucleotides that make up the
                                backbone of nucleic acids, such as DNA. Guanine crystals are, however, less known but
                                can still be found in many organisms like fish, reptiles, and spiders. Guanine
                                crystals are also known to be the excretion product in arachnids and can be found in
                                land crustaceans as well. The organic biogenic crystals have a high refractive index
                                and are therefore commonly used for color and reflective effects in the skin and
                                visual organs. It is also thought to be present in many eukaryotes because guanine is
                                a widespread and abundant metabolite (8).
                            </div>
                            <div className="mt-5">
                                Guanine crystals in eukaryotes have been reported in the cytoplasm of paramecia and
                                other protozoa as well as in microalgae. It is hypothesized that the guanine crystals
                                serve as a purine storage reserve in these organisms. Guanine crystals have not been
                                observed in prokaryotes until Pavan et al. (2023) showed that certain Aeromonas
                                strains, including A. caviae, endogenously produce extracellular guanine crystals (8).
                                Crystal formation was correlated with the absence of the guanine and xanthine
                                degrading enzymes coded by GUAD and XDH genes, respectively.
                            </div>
                            <div className="mt-5">
                                Guanine crystal formation has not been explored or reported in E. coli, which is a
                                more liable organism for upscaling synthetic guanine crystal production, due to its
                                lower biosafety category (BSL1) than Aeromonas species (BSL2 in many countries).
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Description-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Procedure
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                We aim to modify E.coli bacteria to increase guanine production. For this, we intend
                                to increase the expression of the guaA and guaB genes, which are encoding the guanine
                                biosynthesis process key enzymes. GuaA gene encodes for guanosine monophosphate (GMP)
                                synthetase, and the guaB gene encodes for inosine-5’-monophosphate(IMP)
                                dehydrogenase (9). Both enzymes are essential in the GMP synthesis pathway in
                                eukaryotes.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/description/description-2.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="mt-5 text-center">
                                Image 2. iGEM Circular Engineering Cycle: Learn, Design, Build, Test.
                            </div>
                            <div className="mt-5">
                                By constructing a plasmid with guaA and guaB genes along with aeBlue (a chromoprotein,
                                used as a marker for transformation screening) we hope to increase the guanine
                                production. The designed insert was ligated into the pET45b plasmid, the plasmid was
                                amplified and later introduced into BL21(DE3) competent E. coli via chemical
                                transformation. The E.coli culture was left to grow on liquid and later solid media.
                                IPTG was added to liquid culture after being left to grow until OD 0.600 culture
                                density.
                            </div>
                            <div className="mt-5">
                                To verify whether guaA and guaB genes are expressed, we performed the SDS-PAGE and
                                observed the bands of the size that correspond to our target enzyme molecular sizes.
                                Guanine concentration in the transformed cell lysates was tested using a commercially
                                available Guanine Assay kit. Using this assay we can compare (with the aid of the
                                guanine standard curve) the total guanine concentration in the transformed induced,
                                transformed uninduced and non-transformed E.coli.
                            </div>
                            <div className="mt-5">
                                Plates with transformed E.coli were also left to grow to check for crystal formation.
                                Crystal formation is reported to take weeks in bacteria (8), thus we will grow the
                                cultures for a month.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/description/description-3.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="mt-5 text-center">
                                Image 3. Scheme of making guanine a crystal-producing E.coli strain by gauA and
                                guaB overexpression and guaD silencing.
                            </div>
                            <div className="mt-5">
                                In addition to expression guaA and guaB, we aimed to silence guaD and xdh genes. GuaD
                                and XhD genes encode enzymes responsible for guanine catabolism or interconversion,
                                guanine deaminase and xanthine dehydrogenase, respectively. Through CRISPRi (using
                                dead Cas9, dCas9, and guide-RNA) we aim to silence the guaD and xdh genes to further
                                increase the total guanine concentration in the cell and potentially facilitate its
                                crystallization, since in bacterial strains devoid of these genes guanine crystals
                                do form (8).
                            </div>
                            <div className="mt-5">
                                We have reached the phase of designing CRISPRi plasmid (containing dCAs9, gRNA and
                                genetic elements necessary for the expression) with gRNA for guaD gene silencing.
                                Although, we were short in time for plasmid construction and expression tests.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/description/description-4.png"
                                className="w-full mt-5"
                                alt=""
                            />
                            <div className="mt-5 text-center">
                                Image 4: Overall workflow of the experiment. Created with Biorender.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Description-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            References
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <ol className="list-decimal space-y-4">
                                <li>
                                    BBC. Santi. Untraceable ingredients and unrecycled packaging: Why sustainable skincare is so hard to find. [Internet]. 2024. [cited 19 August 2024]. Available from: https://www.bbc.com/future/article/20240215-sustainable-skincare-how-to-make-your-own-moisturiser-at-home
                                </li>
                                <li>
                                    CAS American Chemical Society Science Team. Evolving beauty: the rise of sustainable and natural ingredients for cosmetics. [Internet]. 2024. [cited 19 August 2024] Available from: https://www.cas.org/resources/cas-insights/the-rise-of-natural-ingredients-for-cosmetics
                                </li>
                                <li>
                                    Ayewa Labs. (2023). Ethical Sourcing of Natural and Sustainable Beauty Products: Why Cruelty-Free Isn’t Enough Today. [Internet]. 2023. [cited 19 august 2024] Available from: https://www.linkedin.com/pulse/ethical-sourcing-natural-sustainable-beauty-products-why-cruelty-free-mcg0e
                                </li>
                                <li>
                                    Cosmetics Info. Guanine [Internet]. Washington D.C.: The Personal Care Product Council; 2023 [cited 10 Jun 2024]. Available from: https://www.cosmeticsinfo.org/ingredient/guanine/
                                </li>
                                <li>
                                    Mahtre M, Muniv Y, Thakre R. The extraction of pearl essence from different types of fishes. IJARSCT. 2022;2(3):pages 237-239.
                                </li>
                                <li>
                                    L’oreal Groupe. Mica. (n.d.) (Accessed 2024-08-19) https://inside-our-products.loreal.com/ingredients/mica
                                </li>
                                <li>
                                    Merck. Play with light. [Internet]. (n.d). [cited 19 august 2024]. Available from: https://www.merckgroup.com/en/expertise/effect-pigments/services/basic-pigment-technology.html
                                </li>
                                <li>
                                    Pavan, M. E., Movilla, F., Pavan, E. E., di Salvo, F., López, N. I., & Pettinari, M. J. (2023). Guanine crystal formation by bacteria. BMC Biology, 21(1), 66. https://doi.org/10.1186/s12915-023-01572-8
                                </li>
                                <li>
                                    Ipe, D. S., Sullivan, M. J., Goh, K. G. K., Hashimi, S. M., Munn, A. L., & Ulett, G. C. (2021). Conserved bacterial de novo guanine biosynthesis pathway enables microbial survival and colonization in the environmental niche of the urinary tract. The ISME Journal, 15(7), 2158–2162. https://doi.org/10.1038/s41396-021-00934-w
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

// import Navbar from "../Components/Navbar";
// import Footer from "../Components/Footer";
//
// export default function Description() {
//     return (
//         <div>
//             <Navbar/>
//             <div className="max-h-svh overflow-y-auto max-w-4xl px-4 sm:px-6 lg:px-8 mx-auto mb-16">
//                 <div className="sm:px-24">
//                     <div className="text-2xl font-bold md:text-3xl mt-10">
//                         Guanine Crystals in Cosmetics
//                     </div>
//                     <div className="text-lg text-gray-800 text-justify mt-4">
//                         Guanine crystal, colloquially pearl essence or pearlescence, is an important
//                         ingredient in many cosmetics including skin care, bath, cleansing and nail products,
//                         where it adds opacity and iridescent colour (1). It is primarily sourced from fish
//                         scales, which involves both ethical and ecological issues that in turn present a
//                         barrier to entry for consumers (2). Many of these issues could be resolved if guanine
//                         crystal could be synthesised by synthetic biology.
//                     </div>
//                     <div className="text-2xl font-bold md:text-3xl mt-10">
//                         Guanine Crystals in Bacteria
//                     </div>
//                     <div className="text-lg text-gray-800 text-justify mt-4">
//                         Pavan et al. (2023) showed that certain Aeromonas strains, including A. caviae,
//                         endogenously produce extracellular guanine crystals (3). Crystal formation was
//                         correlated with the absence of the guanine and xanthine degradation genes <span
//                         className="italic">guaD</span> and <span className="italic">xdh</span>. Guanine
//                         crystal formation has not been reported in <span className="italic">E. coli</span>,
//                         which is a more viable species for upscaling of synthetic guanine crystal production,
//                         due to its relatively high safety and level of study.
//                     </div>
//                     <div className="text-2xl font-bold md:text-3xl mt-10">
//                         Our Project
//                     </div>
//                     <div className="text-lg text-gray-800 text-justify mt-4">
//                         Using synthetic biology, we aim to perform guanine crystal production in two ways: by
//                         enhancing it in Aeromonas and inducing it in <span className="italic">E. coli</span>.
//                         In the former, we will introduce a plasmid expressing the guanine synthesis genes <span
//                         className="italic">guaA</span> and <span className="italic">guaB</span>. We hypothesise
//                         that their overexpression will increase guanine crystal formation. In the latter, we will
//                         introduce the same plasmid with the same intent, but will simultaneously perform homologous
//                         recombination to knock out guaD and xdh. This we hypothesize will induce guanine crystal
//                         production in <span className="italic">E. coli</span>.
//                     </div>
//                     <div className="text-2xl font-bold md:text-3xl mt-10">
//                         Ideation
//                     </div>
//                     <div className="text-lg text-gray-800 text-justify mt-4">
//                         We settled on the idea as it intersects with both interests of the team and society;
//                         synthetic biology, cosmetics and environmentalism on the one hand, and growing consumer
//                         and legislative demand for vegan, ethical and eco-friendly cosmetics on the other (4, 5).
//                         Furthermore, the project will allow for the development of new biobricks for <span
//                         className="italic">guaA</span> and <span className="italic">guaB</span> expression, as well
//                         as <span className="italic">guaD</span> and <span className="italic">xdh</span> knockdown.
//                     </div>
//                     <div className="text-2xl font-bold md:text-3xl mt-10">
//                         Reference
//                     </div>
//                     <ol className="list-decimal px-5">
//                         <li className="text-lg text-gray-800 mt-4">
//                             Cosmetics Info. Guanine [Internet]. Washington D.C.: The Personal Care Product Council;
//                             2023 [cited 10 Jun 2024]. Available from: https://www.cosmeticsinfo.org/ingredient/guanine/
//                         </li>
//                         <li className="text-lg text-gray-800 mt-4">
//                             Mahtre M, Muniv Y, Thakre R. The extraction of pearl essence from different types of
//                             fishes. IJARSCT. 2022;2(3):pages 237-239.
//                         </li>
//                         <li className="text-lg text-gray-800 mt-4">
//                             Pavan, M.E., Movilla, F., Pavan, E.E. et al. Guanine crystal formation by bacteria. BMC
//                             Biol21, 66 (2023). https://doi.org/10.1186/s12915-023-01572-8
//                         </li>
//                         <li className="text-lg text-gray-800 mt-4">
//                             Cosmetics Design Europe. New changes to European cosmetics legislation [Internet].
//                             Crawley: William Reed Ltd; 2023 [cited 17 Jun 2024]. Available from:
//                             https://www.cosmeticsdesign-europe.com/Article/2023/10/23/New-changes-to-European-cosmetics-legislation
//                         </li>
//                         <li className="text-lg text-gray-800 mt-4">
//                             Fortune Business Insights. Vegan cosmetics market size, share & industry analysis, by
//                             type (skin care, hair care, makeup, and others), distribution channel (E-commerce,
//                             Hypermarkets / Supermarkets, Department Stores, Specialty Stores, and Others), and
//                             Regional Forecast, 2024-2032 [Internet]. Pune: Fortune Business Insights; 2023 [cited 17
//                             Jun 2024]. Available from: https://www.fortunebusinessinsights.com/vegan-cosmetics-market-106594
//                         </li>
//                     </ol>
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     )
// }